module.exports = __webpack_public_path__ + "img/people-sightseeing-outdoors-rafiki.7e58f0ea.svg";